"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.entries");
var _inOutBound = require("@/api/inOutBound");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  // 给props的title_prfix加上默认值
  props: ['selectedItem'],
  data: function data() {
    var _this = this;
    var validateLicensePlate = function validateLicensePlate(rule, value, callback) {
      if (_this.formData.is_registered == 1 && !value) {
        callback(new Error('请输入车牌'));
      } else {
        callback();
      }
    };
    return {
      btn_disabled: false,
      dialogVisible: false,
      formData: {
        vehicle_id: '',
        name: '',
        purchase_price: undefined,
        chassis_number: '',
        is_registered: undefined,
        remark: '',
        license_plate: ''
      },
      defaultForm: {
        vehicle_id: '',
        name: '',
        purchase_price: undefined,
        chassis_number: '',
        is_registered: undefined,
        remark: '',
        license_plate: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        purchase_price: [{
          required: true,
          message: '请输入进货价格',
          trigger: 'blur'
        }],
        chassis_number: [{
          required: true,
          message: '请输入车架号',
          trigger: 'blur'
        }],
        is_registered: [{
          required: true,
          message: '请选择是否上牌',
          trigger: 'change'
        }],
        license_plate: [{
          required: false,
          trigger: 'blur'
        }],
        remark: [{
          required: false,
          message: '请输入备注',
          trigger: 'blur'
        }],
        evidence_url: [{
          required: false,
          message: '请上传图片',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    // 写一个计算属性，根据props传来的title值，得到新增转账记录还是编辑
    dialogTitle: function dialogTitle() {
      return Object.entries(this.selectedItem).length ? '编辑入库信息' : '添加入库信息';
    },
    isTextarea: function isTextarea() {
      return Object.entries(this.selectedItem).length ? '' : 'textarea';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.formData = Object.assign(this.formData, this.selectedItem);
        console.log('cx', this.formData);
        // 将两个对象的内容合并
      } else {
        this.$refs['formDataRef'].resetFields();
        this.formData = Object.assign(this.formData, this.defaultForm);
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this2 = this;
      // this.$confirm("您确定要申请扣款吗？", "申请扣款", {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消'
      // }).then(() => {
      this.$refs['formDataRef'].validate(function (valid) {
        console.log('valid', valid);
        console.log('this.formData', _this2.formData);
        if (valid) {
          var param = (0, _objectSpread2.default)({}, _this2.formData);
          console.log('最终参数', param);
          if (_this2.formData.is_registered == 2) {
            param.license_plate = undefined;
          }
          // return;
          _this2.btn_disabled = true;
          (0, _inOutBound.editInBoundData)(param).then(function (res) {
            _this2.$emit('getList');
            _this2.close();
          }).catch(function () {}).finally(function () {
            _this2.btn_disabled = false;
          });
        }
      });
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};
exports.default = _default;